import { TreeSelectInput as AntdTreeSelectInput } from "@empglabs/backoffice-ui-kit"

const TreeSelectInput = props => {
  return <AntdTreeSelectInput {...props} />
}

export default TreeSelectInput
